<script lang="ts" module>
  import { TeoCore } from '@/teoCore/TeoCore';
  import { useActiveTeoText } from '@/ui/state/use-text-state.svelte';

  import ConfigPanel from './cmps/ConfigPanel.svelte';
</script>

<script lang="ts">
  let T = useActiveTeoText();
  let TS = $derived($T.store);
  let dynamicConfig$ = TeoCore.current.dynamicConfig;
</script>

{#if $TS.view !== 'new'}
  {#key $TS}
    <ConfigPanel
      selectedOptions={$TS.selectedPromptOptions}
      selectOption={(id: string, value: string) => TS.selectOption(id, value)}
      templates={$dynamicConfig$.promptOptionTemplates ?? []}
      currentTemplate={$TS.currentTemplate}
      selectTemplate={(id: string) => TS.selectTemplate(id)}
      dropdownCategories={$TS.dropdownCategories}
      loading={$dynamicConfig$.promptOptionTemplates === null}
    />
  {/key}
{/if}
